let _csrfToken = ''

export const setCSRFToken = (token) => {
  _csrfToken = token
}

export const getCSRFToken = () => _csrfToken
